import { ClickCardContent } from './click-card-content';
import { ClickCardMetaData } from './click-card-metadata';

export class ClickCardDetails {
    public clickCardMetadata: ClickCardMetaData;
    public clickCardContent: ClickCardContent;
}
